/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.container = document.querySelector('.recently-viewed-container');
      this.url = this.dataset.url ;
      if (!this.url) {
        this.url = window.location.origin + '/search?view=recently-viewed&type=product&q='
      }
      this.productContainer = this.querySelector('.recently-viewed-inner');
      this.currentHandle = this.dataset.handle;
      this.max = +this.dataset.productsToShow;
      this.products = '';
      if (this.dataset.version != "2") {
        this.hideEmptyComponent();
      }
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof recentIds !== undefined) {
          let idsArray = JSON.parse(recentIds);
          window.recentlyViewedIds = idsArray.filter(x => x != this.currentHandle);
        }
      }
    }

    hideEmptyComponent() {
      let isRecentlyViewed = window.localStorage.getItem('recently-viewed');
      let idsArray = JSON.parse(isRecentlyViewed);
      if (idsArray.filter(x => x != this.currentHandle).length === 0) {
        this.container.classList.add('hidden');
      } else {
        this.container.classList.remove('hidden');
      }
    }

    connectedCallback() {
      this.buildUrl()
    }
    buildUrl() {
      let i = 0;
      this.products = '';
      window.recentlyViewedIds.forEach((handle) => {
        if (i >= this.max) {
          return;
        }
        if (handle != this.currentHandle) {
          this.products += 'handle:' + handle + ' OR '
          i++;
        };

      });

      this.url = this.url + encodeURIComponent(this.products);
      if (this.dataset.version == "2") {
        this.renderProducts();
      } else {
         this.fetchProducts();
      }

    }

    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.recently-viewed-inner');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.productContainer.innerHTML = recommendations.innerHTML;
            this.slider = this.querySelector('slider-component');
            this.slider.setUpSliderComponent();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    renderProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const source = html.querySelector('recently-viewed-products');
          const list = html.querySelector('.slider__list');
          const items = Array.from(html.querySelectorAll('.slider__item'));
          if (list) {
            items
              .sort((a, b) => {
                return this.products.indexOf(a.dataset.productHandle) - this.products.indexOf(b.dataset.productHandle);
              })
              .forEach(li => list. appendChild(li));
          }

          if (source)
            HTMLUpdateUtility.setInnerHTML(this, source.innerHTML);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}